import { Router } from './Router';

import { UserContextProvider } from '@contexts/UserContext';
import { AuthContextProvider } from '@contexts/AuthContext';
import { EventsContextProvider } from '@contexts/EventsContext';
import { RegistrationsContextProvider } from '@contexts/RegistrationsContext';
import { ToastContextProvider } from '@acb_devel/design-system';

function App() {
  return (
    <>
      <ToastContextProvider toastPosition="top">
        <AuthContextProvider>
          <UserContextProvider>
            <EventsContextProvider>
              <RegistrationsContextProvider>
                <Router />
              </RegistrationsContextProvider>
            </EventsContextProvider>
          </UserContextProvider>
        </AuthContextProvider>
      </ToastContextProvider>
    </>
  );
}

export default App;
